<template>
  <div>
    <b-card header-class="border-0">
      <div class="card-content">
        <h2>Purchase Gift Card</h2>

        <customer-select-add v-model="form.customerId" />
        <br />
        <base-textarea v-model="form.message" label="Message">
          <template #infoBlock>
            Would you like to send a message with the gift card?
          </template>
        </base-textarea>
      </div>
    </b-card>
    <b-card body-class="p-0" header-class="border-0">
      <div class="card-content">
        <b-tabs card>
          <b-tab no-body title="Terminal Payment">
            <div class="card-content">
              <div class="p-3 card">
                <PayByTerminal
                  :giftCard="form"
                  :amount="null"
                  :customer="customer"
                />
              </div>
            </div>
          </b-tab>
          <b-tab no-body title="Virtual Terminal" lazy>
            <div class="card-content">
              <div class="p-3 card">
                <pay-by-virtual
                  :giftCard="form"
                  :amount="null"
                  :customer="customer"
                />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
  </div>
</template>

<script>
import PayByTerminal from "./PayByTerminal.vue";
import PayByVirtual from "./PayByVirtual.vue";

import CustomerSelectAdd from "@/views/Components/CustomerSelectAdd.vue";
export default {
  components: {
    PayByTerminal,
    CustomerSelectAdd,
    "pay-by-virtual": PayByVirtual,
  },
  props: { customer: null },
  data() {
    return {
      form: {
        customerId: null,
      },
    };
  },
};
</script>

<style></style>
